module.exports = __webpack_public_path__ + "img/hkcc.56d9d7b2.png";